import React, { useState } from 'react'
import { SelectInstitutionButton } from '@/report-app/pages/institution/selectButton'
import { InstitutionDropdown } from '@/report-app/pages/institution/institutionDropdown'
import Resx from '@/components/Resx'

export function InstitutionSelection () {
  const [institution, setInstitution] = useState(null)

  return (
    <div>
      <p><Resx name='Institutions.SelectOneText' /></p>
      <InstitutionDropdown value={institution} onChange={setInstitution} />
      <div className='mt-1'>
        <SelectInstitutionButton institution={institution} />
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/report-app/pages/institution/selection.js